import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, Package, Users, CalendarDays, ArrowUpRight } from "lucide-react";

const F = { fontFamily: 'Barlow Condensed, sans-serif' };

export function StatCards({ stats, isOwner }) {
  const navigate = useNavigate();

  if (isOwner) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card data-testid="total-revenue-card" className="stat-card cursor-pointer" onClick={() => navigate('/revenue')}>
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Total Revenue</span><DollarSign className="w-4 h-4 text-primary" /></div>
            <p className="text-2xl font-bold" style={F}>${(stats?.total_revenue || 0).toLocaleString()}</p>
            <p className="text-xs text-emerald-400 mt-1 flex items-center gap-1"><ArrowUpRight className="w-3 h-3" /> Across all events</p>
          </CardContent>
        </Card>
        <Card data-testid="events-count-card" className="stat-card cursor-pointer" onClick={() => navigate('/events')}>
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Total Events</span><CalendarDays className="w-4 h-4 text-blue-400" /></div>
            <p className="text-2xl font-bold" style={F}>{stats?.total_events || 0}</p>
            <p className="text-xs text-muted-foreground mt-1">{stats?.upcoming_events?.length || 0} upcoming</p>
          </CardContent>
        </Card>
        <Card data-testid="gear-stats-card" className="stat-card cursor-pointer" onClick={() => navigate('/inventory')}>
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Gear Status</span><Package className="w-4 h-4 text-emerald-400" /></div>
            <p className="text-2xl font-bold" style={F}>{stats?.total_gear || 0}</p>
            <p className="text-xs text-muted-foreground mt-1">{stats?.gear_available || 0} available / {stats?.gear_in_use || 0} deployed</p>
          </CardContent>
        </Card>
        <Card data-testid="crew-stats-card" className="stat-card cursor-pointer" onClick={() => navigate('/crew')}>
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Crew</span><Users className="w-4 h-4 text-purple-400" /></div>
            <p className="text-2xl font-bold" style={F}>{stats?.total_crew || 0}</p>
            <p className="text-xs text-muted-foreground mt-1">{stats?.crew_available || 0} available / {stats?.crew_booked || 0} booked</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Card className="stat-card"><CardContent className="p-5">
        <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Gear</span><Package className="w-4 h-4 text-emerald-400" /></div>
        <p className="text-2xl font-bold" style={F}>{stats?.total_gear || 0}</p>
        <p className="text-xs text-muted-foreground mt-1">{stats?.gear_available || 0} available</p>
      </CardContent></Card>
      <Card className="stat-card"><CardContent className="p-5">
        <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Crew</span><Users className="w-4 h-4 text-blue-400" /></div>
        <p className="text-2xl font-bold" style={F}>{stats?.total_crew || 0}</p>
        <p className="text-xs text-muted-foreground mt-1">{stats?.crew_available || 0} available</p>
      </CardContent></Card>
      <Card className="stat-card"><CardContent className="p-5">
        <div className="flex items-center justify-between mb-3"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Events</span><CalendarDays className="w-4 h-4 text-purple-400" /></div>
        <p className="text-2xl font-bold" style={F}>{stats?.total_events || 0}</p>
        <p className="text-xs text-muted-foreground mt-1">{stats?.upcoming_events?.length || 0} upcoming</p>
      </CardContent></Card>
    </div>
  );
}
